import { parse, differenceInCalendarYears } from 'date-fns';
import { matchExact } from './utils';
import { isValidPhoneNumber } from 'libphonenumber-js';

function parseRule(rule) {
  if (typeof rule === 'string' && rule.includes(':')) {
    const [name, paramsString] = rule.split(':');

    const params = paramsString.split(',').map(param => {
      param = param.trim();

      const num = Number(param);
      if (!isNaN(num)) {
        return num;
      }

      return param;
    });

    return {
      rule: name.trim(),
      params: params,
    };
  }

  return {
    rule: typeof rule === 'string' ? rule.trim() : rule,
    params: [],
  };
}

function validateRule(rule, value) {
  let age;
  const dateInstance = new Date();

  switch (rule.rule) {
    case 'required':
      return !value ? 'ERROR_REQUIRED' : null;
    case 'min':
      return value && value.length < rule.params[0] ? `ERROR_MIN_LENGTH_${rule.params[0]}` : null;
    case 'max':
      return value && value.length > rule.params[0] ? `ERROR_MAX_LENGTH_${rule.params[0]}` : null;
    case 'min_age':
      age = differenceInCalendarYears(dateInstance, parse(value, rule.params[1], dateInstance));

      if (!Number(age)) {
        return 'ERROR_DATE_FORMAT';
      }

      return value && age < rule.params[0] ? `ERROR_MIN_AGE_${rule.params[0]}` : null;
    case 'max_age':
      age = differenceInCalendarYears(dateInstance, parse(value, rule.params[1], dateInstance));

      if (!Number(age)) {
        return 'ERROR_DATE_FORMAT';
      }

      return value && age > rule.params[0] ? `ERROR_MAX_AGE_${rule.params[0]}` : null;
    case 'email':
      return !matchExact(/^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/, value) ? 'ERROR_WRONG_EMAIL' : null;
    case 'phone_number':
      return !isValidPhoneNumber(value) ? 'VALID_NUMBER' : null;
  }
}

function validateRegex(regex, value) {
  return !matchExact(new RegExp(regex), value) ? 'ERROR_WRONG_FORMAT' : null;
}

function validateField(value, rules = [], regex, errorMessages) {
  for (const rule of rules) {
    const parsedRule = parseRule(rule);
    const ruleValidation = validateRule(parsedRule, value);
    if (ruleValidation) {
      return errorMessages?.[parsedRule.rule] || ruleValidation;
    }
  }

  if (regex && value) {
    const regexValidation = validateRegex(regex, value);
    if (regexValidation) {
      return errorMessages?.regex || regexValidation;
    }
  }

  return null;
}

const validateForm = (data, rules) => {
  const errors = {};

  Object.keys(rules).forEach(key => {
    const value = data[key];
    const rule = rules[key];

    const globalValidation = validateField(value, rule.rules, rule.regex, rule.errorMessages);

    if (globalValidation) {
      errors[key] = globalValidation;
      return;
    }

    if (rule.customValidation) {
      const customValidation = rule.customValidation(value, data);

      if (customValidation) {
        errors[key] = customValidation;
      }
    }
  })

  return errors;
};

export { validateForm };
